import React, { Component } from 'react'
import { UserDataContext } from './withAuth'

export default function withUserData(ComponentWithUserData) {
    class WithUserDataWrapper extends Component {
        static contextType = UserDataContext

        render() {
            const { forwardedRef, ...rest } = this.props
            return (
                <ComponentWithUserData
                    userData={this.context}
                    ref={forwardedRef}
                    {...rest}
                />
            )
        }
    }
    return React.forwardRef((props, ref) => {
        return <WithUserDataWrapper {...props} forwardedRef={ref} />
    })
}
